import { SupportedLocale } from '@/types/supported-locale.type';
import StyledButton from '../styled/StyledButton';
import ResourceLanguageSwitch from './ResourceLanguageSwitch';
import { useLanguage } from '@/contexts/LanguageContext';
import Modal from '../ui/Modal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitchWithTranslateBtnProps {
  translateFields: () => Promise<void>;
  isTranslating: boolean;
  language: SupportedLocale;
  setLanguage: React.Dispatch<React.SetStateAction<SupportedLocale>>;
  hideTranslateBtn?: boolean;
}

const LanguageSwitchWithTranslateBtn = ({
  translateFields,
  isTranslating,
  language,
  setLanguage,
  hideTranslateBtn = false,
}: LanguageSwitchWithTranslateBtnProps) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const [
    isTranslateToAllLanguagesModalOpen,
    setIsTranslateToAllLanguagesModalOpen,
  ] = useState(false);

  return (
    <>
      <div className="flex flex-row-reverse md:w-fit md:sticky md:top-20 md:left-full px-6 py-2 z-10">
        <div className="flex flex-row items-center gap-4 w-full">
          {!hideTranslateBtn && (
            <StyledButton
              title={t('modal.translateToAllLanguages.title')}
              variant="outlined"
              onClick={() => setIsTranslateToAllLanguagesModalOpen(true)}
              disabled={isTranslating}
              className="px-3 border-warning-300 text-black"
            />
          )}
          <ResourceLanguageSwitch
            language={language}
            setLanguage={setLanguage}
            shouldHighlight={currentLanguage !== language}
          />
        </div>
      </div>
      {isTranslateToAllLanguagesModalOpen && (
        <TranslateToAllLanguagesModal
          closeModal={() => setIsTranslateToAllLanguagesModalOpen(false)}
          translateFields={translateFields}
        />
      )}
    </>
  );
};

export default LanguageSwitchWithTranslateBtn;

interface TranslateToAllLanguagesModalProps {
  closeModal: () => void;
  translateFields: () => void;
}

const TranslateToAllLanguagesModal = ({
  closeModal,
  translateFields,
}: TranslateToAllLanguagesModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('modal.translateToAllLanguages.title')}
      closeModal={closeModal}
      actionTitle={t('modal.translateToAllLanguages.actionTitle')}
      actionOnClick={translateFields}
      message={t('modal.translateToAllLanguages.message')}
    />
  );
};
